/*
  Mublio deurtje – touch-gedrag. Desktop werkt met alleen CSS (hover).
  Op touch (geen hover) opent een tik het deurtje snel; is het paneel een link,
  dan gaat de pagina daarna (na de animatie) naar de link. Een paneel zonder link
  gaat open en dicht per tik. Elk paneel stuurt het event "mb-deurtje" (detail.open),
  zodat een sectie bijvoorbeeld de video kan laten spelen.
*/
(() => {
  if (window.mbDeurtje) return;
  window.mbDeurtje = true;

  const touch = window.matchMedia('(hover: none)');
  const rustig = window.matchMedia('(prefers-reduced-motion: reduce)');

  const meld = (deur) =>
    deur.dispatchEvent(new CustomEvent('mb-deurtje', { bubbles: true, detail: { open: deur.classList.contains('is-open') } }));

  const sluitAndere = (deur) =>
    document.querySelectorAll('.mb-deurtje.is-open').forEach((d) => {
      if (d !== deur) {
        d.classList.remove('is-open');
        meld(d);
      }
    });

  document.addEventListener('click', (event) => {
    if (!touch.matches || event.defaultPrevented) return;
    const deur = event.target.closest('.mb-deurtje');
    if (!deur) return;

    sluitAndere(deur);

    const link = deur.matches('a[href]') ? deur : null;
    if (!link) {
      deur.classList.toggle('is-open');
      meld(deur);
      return;
    }

    if (rustig.matches || deur.classList.contains('is-open')) return;

    event.preventDefault();
    deur.classList.add('is-open');
    meld(deur);

    const duur = parseFloat(getComputedStyle(deur).transitionDuration) * 1000 || 300;
    setTimeout(() => {
      if (link.target === '_blank') window.open(link.href, '_blank', 'noopener');
      else window.location.href = link.href;
    }, duur);
  });

  /* Terug naar de pagina (bfcache): deurtjes weer dicht */
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.mb-deurtje.is-open').forEach((d) => d.classList.remove('is-open'));
  });
})();
